export default "__VITE_ASSET__CdZMOpD$__"